import api from './api';

function hexToHslString(hex) {
  if (!hex) return null;
  const clean = hex.replace('#', '');
  if (clean.length !== 6) return null;
  const r = parseInt(clean.slice(0, 2), 16) / 255;
  const g = parseInt(clean.slice(2, 4), 16) / 255;
  const b = parseInt(clean.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s;
  const l = (max + min) / 2;
  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

/** Fetches admin-configured brand colors and layers them on top of the base
 * theme via an injected <style> tag, so :root (light) and .dark stay correctly
 * separate. Safe no-op if the admin hasn't set any overrides. */
export async function applyThemeOverrides() {
  try {
    const { data } = await api.get('/theme-settings');
    const lightPrimary = hexToHslString(data.light_primary);
    const lightAccent = hexToHslString(data.light_accent);
    const darkPrimary = hexToHslString(data.dark_primary);
    const darkAccent = hexToHslString(data.dark_accent);
    if (!lightPrimary && !lightAccent && !darkPrimary && !darkAccent) return;

    let css = '';
    if (lightPrimary || lightAccent) {
      css += `:root{${lightPrimary ? `--primary:${lightPrimary};` : ''}${lightAccent ? `--accent:${lightAccent};` : ''}}\n`;
    }
    if (darkPrimary || darkAccent) {
      css += `.dark{${darkPrimary ? `--primary:${darkPrimary};` : ''}${darkAccent ? `--accent:${darkAccent};` : ''}}\n`;
    }
    let tag = document.getElementById('admin-theme-overrides');
    if (!tag) {
      tag = document.createElement('style');
      tag.id = 'admin-theme-overrides';
      document.head.appendChild(tag);
    }
    tag.textContent = css;
  } catch {
    // No theme overrides configured, or request failed — silently keep defaults.
  }
}
